import React from "react";
import { Link, useParams } from "react-router-dom";
import IntroVideo from '../../videos/Axis_background.mp4';
import VideoComponent from '../VideoComponent.js';
import PageSEO from "../../components/seo/PageSEO";
import { useScrollBehavior } from '../useScrollBehavior.js';
import { BLOG_POSTS } from "./blogData";
import "../../styles/home.css";
import "../../styles/blog.css";

export default function BlogPost() {
  useScrollBehavior();

  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);

  if (!post) {
    return (
      <main className="home">
        <PageSEO title="Not Found | Blog" noindex path={`/blog/${slug || ""}`} />
        <div className="home__bg" aria-hidden="true">
          <VideoComponent videoSrc={IntroVideo} />
        </div>
        <section className="home__content">
          <div className="module blog-post__not-found">
            <h1 className="home__title">Post not found</h1>
            <Link className="btn btn--ghost" to="/blog">← Back to Blog</Link>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="home">
      <PageSEO
        title={`${post.title} | The Axis`}
        description={post.excerpt}
        path={`/blog/${post.slug}`}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": post.title,
          "datePublished": post.date,
          "description": post.excerpt,
          "author": {
            "@type": "Person",
            "name": post.author || "The Axis"
          }
        }}
      />

      <div className="home__bg" aria-hidden="true">
        <VideoComponent videoSrc={IntroVideo} />
      </div>

      <section className="home__content">
        <div className="module blog-post__module">

          {/* ── BACK + META ── */}
          <div className="blog-post__nav">
            <Link className="blog-post__back" to="/blog">← Blog</Link>
            <div className="blog-post__meta">
              {post.category && (
                <span className="blog-card__category">{post.category}</span>
              )}
              <span className="blog-card__date">{post.date}</span>
              {post.author && (
                <span className="blog-post__author">by {post.author}</span>
              )}
            </div>
          </div>

          {/* ── TITLE ── */}
          <h1 className="blog-post__title">{post.title}</h1>
          <p className="blog-post__excerpt">{post.excerpt}</p>

          {/* ── IMAGE SLOT ── */}
          {post.image ? (
            <div className="blog-post__image">
              <img src={post.image} alt={post.title} />
            </div>
          ) : (
            <div
              className="blog-post__image blog-post__image--placeholder"
              aria-hidden="true"
            />
            // Replace null with an imported image in blogData.js to fill this slot
          )}

          {/* ── PULL QUOTE ── */}
          {post.pullQuote && (
            <blockquote className="blog-post__pullquote">
              {post.pullQuote}
            </blockquote>
          )}

          {/* ── BODY ── */}
          <div className="blog-post__body">
            {post.content.map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>

          {/* ── RELATED LINKS ── */}
          {post.links && post.links.length > 0 && (
            <div className="blog-post__links">
              <h3 className="blog-post__links-heading">Further Reading</h3>
              <ul className="blog-post__links-list">
                {post.links.map((link, idx) => (
                  <li key={idx}>
                    <a
                      href={link.url}
                      className="blog-post__link"
                      target={link.url.startsWith('http') ? '_blank' : undefined}
                      rel={link.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                    >
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* ── CTA ── */}
          <div className="blog-post__cta">
            <Link className="btn btn--primary" to="/join">Join the Axis</Link>
            <Link className="btn btn--ghost" to="/blog">← All Posts</Link>
          </div>

        </div>
      </section>
    </main>
  );
}



/*import React from "react";
import { Link, useParams } from "react-router-dom";
import PageSEO from "../../components/seo/PageSEO";
import "../../styles/blog.css";
import { BLOG_POSTS } from "./blogData";
import { useScrollBehavior } from '../useScrollBehavior.js';

export default function BlogPost({ match }) {

  useScrollBehavior();

  const slug = match?.params?.slug;
  const post = BLOG_POSTS.find((p) => p.slug === slug);

  if (!post) {
    return (
      <main className="page">
        <PageSEO title="Not Found | Blog" noindex path={`/blog/${slug || ""}`} />
        <header className="pageHeader">
          <h1>Post not found</h1>
          <p><Link to="/blog">Back to blog</Link></p>
        </header>
      </main>
    );
  }

  return (
    <main className="page">
      <PageSEO
        title={`${post.title} | Blog`}
        description={post.excerpt}
        path={`/blog/${post.slug}`}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": post.title,
          "datePublished": post.date,
          "description": post.excerpt
        }}
      />

      <header className="pageHeader">
        <p className="kicker"><Link to="/blog">← Blog</Link></p>
        <h1>{post.title}</h1>
        <p className="meta">{post.date}</p>
      </header>

      <article className="article">
        {post.content.map((para, idx) => (
          <p key={idx}>{para}</p>
        ))}

        <div className="ctaRow">
          <Link className="btnPrimary" to="/app">Get the App</Link>
          <Link className="btnSecondary" to="/book">Get the Book</Link>
        </div>
      </article>
    </main>
  );
}*/
